import { render, staticRenderFns } from "./UserGenerator.vue?vue&type=template&id=3b3b1849&"
import script from "./UserGenerator.vue?vue&type=script&lang=ts&"
export * from "./UserGenerator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports